"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-unused-state */
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var react_1 = __importStar(require("react"));
var ExperimentProviderContext_1 = __importDefault(require("./ExperimentProviderContext"));
var RegisterMultipleExperiments_1 = __importDefault(require("./Experiment/RegisterMultipleExperiments"));
var defaultProps = {
    serverCookies: {},
    defaults: {},
    preloadedExperiments: {},
    onPageLoadExperiments: {}
};
var ExperimentProvider = /** @class */ (function (_super) {
    __extends(ExperimentProvider, _super);
    function ExperimentProvider(props) {
        var _this = _super.call(this, props) || this;
        var serverCookies = props.serverCookies, defaults = props.defaults, preloadedExperiments = props.preloadedExperiments, onPageLoadExperiments = props.onPageLoadExperiments;
        _this.state = {
            experiments: __assign(__assign({}, onPageLoadExperiments), preloadedExperiments),
            updateExperiment: function (name, updatedExperiments) {
                _this.setState(function (_a) {
                    var _b;
                    var experiments = _a.experiments;
                    return ({
                        experiments: __assign(__assign({}, experiments), (_b = {}, _b[name] = updatedExperiments[name], _b))
                    });
                });
            },
            serverCookies: serverCookies,
            defaults: defaults
        };
        return _this;
    }
    ExperimentProvider.prototype.componentDidMount = function () {
        var onPageLoadExperiments = this.props.onPageLoadExperiments;
        if (onPageLoadExperiments) {
            this.registerPageLoadExperiments();
        }
    };
    ExperimentProvider.prototype.componentDidUpdate = function (prevProps) {
        var onPageLoadExperiments = this.props.onPageLoadExperiments;
        var currentExperimentNames = Object.keys(onPageLoadExperiments);
        var prevExperimentNames = Object.keys(prevProps.onPageLoadExperiments);
        if (currentExperimentNames.length !== prevExperimentNames.length ||
            !fast_deep_equal_1.default(onPageLoadExperiments, prevProps.onPageLoadExperiments)) {
            this.registerPageLoadExperiments();
        }
    };
    ExperimentProvider.prototype.registerPageLoadExperiments = function () {
        var onPageLoadExperiments = this.props.onPageLoadExperiments;
        var _a = this.state, experiments = _a.experiments, updateExperiment = _a.updateExperiment, serverCookies = _a.serverCookies, defaults = _a.defaults;
        var experimentsToRegister = Object.entries(onPageLoadExperiments).map(function (_a) {
            var key = _a[0], value = _a[1];
            var _b = onPageLoadExperiments[key].defaultBucket, defaultBucket = _b === void 0 ? 'control' : _b;
            return __assign({ experimentName: key, defaultBucket: defaultBucket }, (value.identifier && { identifier: value.identifier }));
        });
        RegisterMultipleExperiments_1.default(__assign(__assign({}, defaults), { experimentsToRegister: experimentsToRegister, ignoreExistingExperiments: true, experiments: experiments,
            serverCookies: serverCookies }), updateExperiment);
    };
    ExperimentProvider.prototype.render = function () {
        var children = this.props.children;
        return (react_1.default.createElement(ExperimentProviderContext_1.default.Provider, { value: this.state }, children));
    };
    ExperimentProvider.defaultProps = defaultProps;
    return ExperimentProvider;
}(react_1.PureComponent));
exports.default = ExperimentProvider;
